import { useRole } from "../hooks/useRole";
import { Menu } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export default function RoleSwitcher() {
  const { role, setRole } = useRole();

  return (
    <Menu as="div" className="relative ml-3">
      <div>
        <Menu.Button className="flex items-center rounded-full bg-gray-800 px-3 py-1 text-sm font-medium text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
          <span className="mr-1">{role === "husband" ? "♂️" : "♀️"}</span>
          <span className="capitalize">{role}</span>
          <ChevronDownIcon className="ml-1 h-4 w-4" aria-hidden="true" />
        </Menu.Button>
      </div>
      <Menu.Items className="absolute right-0 z-10 mt-2 w-40 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none transition duration-100 ease-out data-[closed]:scale-95 data-[closed]:opacity-0">
        <Menu.Item>
          {({ active }) => (
            <button
              onClick={() => setRole("husband")}
              className={classNames(
                active ? "bg-gray-100" : "",
                role === "husband"
                  ? "bg-indigo-50 text-indigo-700 font-semibold"
                  : "text-gray-700",
                "block w-full text-left px-4 py-2 text-sm"
              )}
            >
              <span className="mr-2">♂️</span>
              Husband
            </button>
          )}
        </Menu.Item>
        <Menu.Item>
          {({ active }) => (
            <button
              onClick={() => setRole("wife")}
              className={classNames(
                active ? "bg-gray-100" : "",
                role === "wife"
                  ? "bg-indigo-50 text-indigo-700 font-semibold"
                  : "text-gray-700",
                "block w-full text-left px-4 py-2 text-sm"
              )}
            >
              <span className="mr-2">♀️</span>
              Wife
            </button>
          )}
        </Menu.Item>
      </Menu.Items>
    </Menu>
  );
}
